import { Button, Modal, Row, Table } from 'antd';

import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { useCapturePostHog } from '../../../../hooks/useCapturePostHog';
import type { SortedInfo } from '../../../../models/table';
import type { DashboardModalType, TotalClientDetail } from './modalDashboardSlice';
import { clearModalFilter, closeDashboardModal, DASHBOARD_MODAL, handleModalTableChange } from './modalDashboardSlice';
import { GetTotalClientModalProps } from './total-client-modal-props';

export const TotalClientModal = ({ data, filtersInfo }: { data: TotalClientDetail[] | null; filtersInfo: string }) => {
  const dispatch = useAppDispatch();
  const { capturePostHogCustomEvent } = useCapturePostHog();
  const open = useAppSelector((state) => state.modalDashboardSlice.modal === DASHBOARD_MODAL.TOTAL_CLIENT);
  const { columns, clearSearch } = GetTotalClientModalProps();

  return (
    <Modal
      className="dashboardModal"
      width={'65%'}
      title="Total client details"
      open={open}
      onCancel={() => {
        capturePostHogCustomEvent('TotalClientModal close modal');
        dispatch(closeDashboardModal());
      }}
      mask={{ blur: false, closable: false }}
      footer={null}
    >
      <Row className="filtersInfoRow" justify="space-between" align="middle">
        <p style={{ marginTop: 'auto', marginBottom: 'auto' }}>{filtersInfo}</p>
        <Button
          onClick={() => {
            dispatch(clearModalFilter());
            clearSearch();
            dispatch(
              handleModalTableChange({
                sorter: {
                  columnKey: 'full_name',
                  field: 'full_name',
                  order: 'ascend',
                },
              }),
            );
            capturePostHogCustomEvent('TotalClientModal clear filters');
          }}
        >
          Clear filters
        </Button>
      </Row>
      <Table
        className="dashboardTable"
        columns={columns}
        rowKey="id"
        onChange={(pagination, filters, sorter) => {
          dispatch(handleModalTableChange({ pagination, filters, sorter: sorter as SortedInfo<DashboardModalType> }));
          capturePostHogCustomEvent('TotalClientModal table change');
        }}
        pagination={
          data && data?.length > 20
            ? {
                showTotal: (total, range) => {
                  return `Showing ${range[0]}-${range[1]} of ${total} results`;
                },
                placement: ['bottomEnd'],
                defaultPageSize: 20,
              }
            : false
        }
        dataSource={data || undefined}
        scroll={{ y: 'calc(100vh - 400px)' }}
      />
    </Modal>
  );
};
